/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_Next_Empty_TitleInputs */

const en_hero_next_empty_title = /** @type {(inputs: Hero_Next_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Booking opens soon`)
};

const pl_hero_next_empty_title = /** @type {(inputs: Hero_Next_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezerwacje otwierają się wkrótce`)
};

/**
* | output |
* | --- |
* | "Booking opens soon" |
*
* @param {Hero_Next_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const hero_next_empty_title = /** @type {((inputs?: Hero_Next_Empty_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_Next_Empty_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_hero_next_empty_title(inputs)
	return en_hero_next_empty_title(inputs)
});